import React from 'react';
import { List } from 'react-admin';
import { ReactAdminPagination } from '../components/ui/react-admin-pagination';
import { ListScreen } from '../components/ui/list-screen';
import { DataTable, DataColumn } from '../components/ui/data-table';
import { StatusBadge } from '../components/ui/data-cells';
import { cop } from './payments';

interface RefundItem {
  id: number;
  payment_id: number;
  amount: number;
  reason: string;
  status: string;
  provider_refund_id?: string;
  created_at: string;
  processed_at?: string;
}
const fmtDate = (v?: string | null) =>
  v
    ? new Date(v).toLocaleString('en-US', {
        month: 'short',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '—';

const ListBody = () => {
  const columns: DataColumn<RefundItem>[] = [
    { key: 'id', header: 'ID', width: '1px', cell: (r) => <span className="tabular-nums text-ink-2">#{r.id}</span> },
    { key: 'payment_id', header: 'Payment', cell: (r) => <span className="tabular-nums text-ink">#{r.payment_id}</span> },
    { key: 'amount', header: 'Amount', align: 'right', cell: (r) => <span className="tabular-nums font-medium">{cop(r.amount)}</span> },
    { key: 'reason', header: 'Reason', cell: (r) => <span className="truncate text-ink">{r.reason}</span> },
    { key: 'created_at', header: 'Created', cell: (r) => fmtDate(r.created_at) },
    { key: 'processed_at', header: 'Processed', cell: (r) => fmtDate(r.processed_at) },
    { key: 'status', header: 'Status', cell: (r) => <StatusBadge status={r.status} /> },
  ];
  return (
    <ListScreen>
      <DataTable columns={columns} emptyMessage="No refunds." />
      <div className="pt-1">
        <ReactAdminPagination />
      </div>
    </ListScreen>
  );
};

export const RefundList = (props: any) => (
  <List {...props} actions={false} empty={false} pagination={false} sort={{ field: 'created_at', order: 'DESC' }} perPage={25} component="div">
    <ListBody />
  </List>
);
